import React from 'react';
import { styles } from './Card.css';
import { Base, LoadingSkeletonProps } from '../../Base/Base';
import { BaseCard } from '../../../Card';
import { TextBlock } from '../TextBlock/TextBlock';
import { Box } from '../Box/Box';

type CardSkeletonProps = { isContained?: boolean } & LoadingSkeletonProps;

export const Card = ({ shouldShimmer = false, isContained = true, ...baseProps }: CardSkeletonProps) => {
  return (
    <Base {...baseProps} className={styles.container}>
      <BaseCard
        isContained={isContained}
        cover={<Box backgroundColor="#f0f0f0" shouldShimmer={shouldShimmer} />}
      >
        <TextBlock
          lines={[
            { width: '225px', height: '18px', shouldShimmer, backgroundColor: '#f0f0f0' },
            { width: '250px', shouldShimmer, backgroundColor: '#f0f0f0' },
          ]}
        />
      </BaseCard>
    </Base>
  );
};
